import { Card, theme } from 'antd';
import { useTheme } from 'context/ThemeContext';
import { getCardIcon } from 'theme/themes/themeMeta';

const CustomCard = ({ title, extra, showThemeFlag = false, style, styles: stylesProp, ...rest }) => {
    const { token } = theme.useToken();
    const { theme: appTheme } = useTheme();
    const cardIcon = getCardIcon(appTheme);

    const flag =
        typeof cardIcon === 'string' && cardIcon ? (
            <img src={cardIcon} height={38} alt="" />
        ) : null;

    return (
        <Card
            bordered={true}
            className="detail-card-with-action-header"
            title={
                <div className="detail-card-header">
                    <div
                        className="detail-card-header-title"
                        style={{
                            color: token.moduleMenuItemColor ?? token.colorTextLightSolid ?? '#fff',
                            textTransform: 'uppercase',
                        }}
                    >
                        <span>{title}</span>
                    </div>
                </div>
            }
            extra={
                extra || (showThemeFlag && flag) ? (
                    <div
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 12,
                        }}
                    >
                        {extra}
                        {showThemeFlag ? flag : null}
                    </div>
                ) : undefined
            }
            styles={{
                ...stylesProp,
                header: {
                    minHeight: 'auto',
                    padding: '6px 16px',
                    backgroundColor: token.moduleMenuBg ?? token.colorPrimary,
                    borderTopLeftRadius: token.borderRadiusLG ?? 8,
                    borderTopRightRadius: token.borderRadiusLG ?? 8,
                    ...(stylesProp?.header || {}),
                },
            }}
            style={{ marginTop: 0, ...style }}
            {...rest}
        />
    );
};
export default CustomCard;
